import React, { useState } from "react";
import { CheckCircle2, XCircle, ChevronRight } from "lucide-react";

const JOB_TONE = { frontend: "text-sky-300", "backend-guards": "text-violet-300", "backend-openapi-guard": "text-emerald-300", extra: "text-white/50" };

export default function BuildCheckSteps({ steps, total, running }) {
    const pending = Math.max(0, (total || 0) - steps.length);
    return (
        <div className="bg-[#0a0a0a] border border-white/10 rounded-md divide-y divide-white/5" data-testid="build-check-steps">
            {steps.map((s, i) => <StepRow key={`${s.job}-${s.name}`} step={s} index={i} />)}
            {running && pending > 0 && (
                <div className="px-4 py-3 text-[11px] font-mono text-white/40 flex items-center gap-2" data-testid="build-check-steps-pending">
                    <span className="w-1.5 h-1.5 rounded-full bg-amber-300 animate-pulse" /> {pending} more check{pending === 1 ? "" : "s"} to run…
                </div>
            )}
            {!steps.length && !running && <div className="px-4 py-6 text-xs text-white/40 text-center" data-testid="build-check-steps-empty">No run yet.</div>}
        </div>
    );
}

function StepRow({ step, index }) {
    const [open, setOpen] = useState(!step.ok);
    const Icon = step.ok ? CheckCircle2 : XCircle;
    return (
        <div data-testid={`build-check-step-${index}`}>
            <button onClick={() => setOpen((v) => !v)} className="w-full px-4 py-2.5 flex items-center gap-3 text-left hover:bg-white/[0.02] transition-colors"
                data-testid={`build-check-step-toggle-${index}`}>
                <Icon className={`w-4 h-4 flex-shrink-0 ${step.ok ? "text-emerald-300" : "text-red-400"}`} />
                <span className={`text-[10px] font-mono uppercase w-40 flex-shrink-0 truncate ${JOB_TONE[step.job] || "text-white/50"}`}>{step.job}</span>
                <span className="text-xs flex-1 min-w-0 truncate">{step.name}</span>
                <span className="text-[11px] font-mono text-white/40">{step.seconds}s</span>
                <ChevronRight className={`w-3.5 h-3.5 text-white/30 transition-transform ${open ? "rotate-90" : ""}`} />
            </button>
            {open && (
                <div className="px-4 pb-3 pl-11 space-y-2">
                    {step.errors?.length > 0 && (
                        <ul className="text-[11px] font-mono text-red-200/90 space-y-0.5" data-testid={`build-check-step-errors-${index}`}>
                            {step.errors.map((e, i) => <li key={i} className="break-words">{e}</li>)}
                        </ul>
                    )}
                    <pre className="text-[10px] font-mono text-white/50 bg-black/40 border border-white/5 rounded p-2 max-h-64 overflow-auto whitespace-pre-wrap break-words"
                        data-testid={`build-check-step-output-${index}`}>{step.output_tail || "(no output)"}</pre>
                </div>
            )}
        </div>
    );
}
